import React from 'react'
import ContactSection from '../component/ContactSection'
import ContactHero from '../component/ContactHero'
import LocationSection from '../component/LocationSection'
import FAQsSectionContact from '../component/FAQsSectionContact'

const Contact = () => {
  return (
   <>
   <ContactHero/>
   <LocationSection/>
   <ContactSection />
   <FAQsSectionContact/>
   </>
  )
}

export default Contact
